import React from 'react'
import {Routes,Route, useLocation, useNavigate} from 'react-router-dom'
import SignIn from '../pages/Authorization/SignIn'
import ForgotPassword from '../pages/Authorization/ForgotPassword'
import SendOTP from '../pages/Authorization/SendOTP'
import ChangePassword from '../pages/Authorization/ChangePassword'
import ResetPassword from '../pages/Authorization/ResetPassword'

const Routing = () => {
 
  return (
    <>
      <Routes>
      {/* Authoriszation Routes  */}
        <Route path='/' element={<SignIn/>}/>
        <Route path='/forgotpassword' element={<ForgotPassword/>} />
        <Route path="/sendotp" element={<SendOTP/>} />
        <Route path="/changepassword" element={<ChangePassword />} />
        <Route path="/resetpassword" element={<ResetPassword/>} />
    </Routes>
    </>
  )
}

export default Routing
